import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { GradeStatus } from '../../../../models/grade.school.model';
import { UtilsService } from '../../../../services/utils.service';
import { AppState } from '../../../../state/appstate';

@Component({
  selector: 'app-dlg-add-grade',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './dlg-add-grade.component.html',
  styleUrl: './dlg-add-grade.component.css',
})
export class DlgAddGradeComponent {
  readonly dialogRef = inject(MatDialogRef<DlgAddGradeComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  private dialog: MatDialog = inject(MatDialog);
  store: Store<AppState> = inject(Store<AppState>);
  utilsService: UtilsService = inject(UtilsService);
  fb = inject(FormBuilder);

  pageForm: FormGroup = new FormGroup({});

  title: string = 'Create Grade';
  description: string = 'Enter the Name of the Grade';
  action: string = 'Create';
  // faculty: SchoolMember[] | undefined;

  exit$: Subject<void> = new Subject();

  constructor() {
    this.pageForm = this.fb.group({
      gradeName: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
      ]),
      gradeAvgAge: new FormControl(
        this.data.grade?.gradeAvgAge ?? '',
        Validators.required,
      ),
      // teacherId: new FormControl(this.data.grade?.teacherId ?? 'unassigned'),
    });
    // this.faculty = this.data.faculty;
  }

  ngOnDestroy(): void {
    this.exit$.next();
    this.exit$.complete();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (
      this.pageForm.invalid ||
      this.data.groupId == undefined ||
      (this.data.grade?.gradeYear == undefined &&
        this.data.academicYear == undefined)
    ) {
      // console.log(
      //   `Form Invalid: ${this.pageForm.invalid} GroupId: ${this.data.groupId}, ${this.data.grade?.gradeYear}, ${this.data.academicYear}`
      // );
      this.utilsService.onShowAlert(
        {
          code: 'ERR_FORM_INVALID',
          title: 'Pre-requisites not met',
          message:
            'Invalid form data or pre-requisite fields unavailable. Please try again later',
        },
        false,
      );
      return;
    }

    // this.working = of(true);

    const result = this.pageForm.value;

    // const teacher: SchoolMember | undefined = this.faculty?.find(
    //   (f) => f.memberId === result.teacherId
    // );
    let grade: any = {
      gradeName: result.gradeName,
      gradeStatus: GradeStatus.active,
      gradeAvgAge: result.gradeAvgAge,
      groupId: this.data.groupId,
      teacherId: 'unassigned',
      teacherName: 'unassigned',
      teacherPhotoUrl: '',
    };

    this.dialogRef.close(grade);
  }
}
